import { render } from "./reservationsView.vue?vue&type=template&id=47baa2fe&scoped=true"
import script from "./reservationsView.vue?vue&type=script&lang=js"
export * from "./reservationsView.vue?vue&type=script&lang=js"

import "./reservationsView.vue?vue&type=style&index=0&id=47baa2fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47baa2fe"]])

export default __exports__